function Intro() {
  return <div>Meuturi</div>;
}

export default Intro;
